import React from "react";
import {
  Box,
  Container,
  Stack,
  SimpleGrid,
  Text,
  Link,
  Flex,
  Divider,
  Image,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

const Footer = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  const translations = {
    en: {
      product: "Product",
      company: "Company",
      resources: "Resources",
      legal: "Legal",
      footerLinks: {
        product: [
          { label: "Features", path: "/products" },
          { label: "Pricing", path: "/products" },
          { label: "Updates", path: "/products" },
        ],
        company: [
          { label: "About Us", path: "/about" },
          { label: "Careers", path: "/about" },
          { label: "Contact", path: "/contact" },
        ],
        resources: [
          { label: "Documentation", path: "/products" },
          { label: "Support", path: "/contact" },
          { label: "Blog", path: "/" },
        ],
        legal: [
          { label: "Privacy Policy", path: "/" },
          { label: "Terms of Service", path: "/" },
          { label: "Cookie Policy", path: "/" },
        ],
      },
      copyright: "© 2025 Aidu. All rights reserved.",
    },
    ko: {
      product: "제품",
      company: "회사",
      resources: "자료",
      legal: "법적 고지",
      footerLinks: {
        product: [
          { label: "기능", path: "/products" },
          { label: "요금제", path: "/products" },
          { label: "업데이트", path: "/products" },
        ],
        company: [
          { label: "회사 소개", path: "/about" },
          { label: "문의", path: "/contact" },
        ],
        resources: [
          { label: "문서", path: "/products" },
          { label: "고객 지원", path: "/contact" },
          { label: "블로그", path: "/" },
        ],
        legal: [
          { label: "개인정보 보호정책", path: "/" },
          { label: "서비스 이용약관", path: "/" },
          { label: "쿠키 정책", path: "/" },
        ],
      },
      copyright: "© 2025 Aidu. 모든 권리 보유.",
    },
  };

  const t = translations[language] || translations.en;

  return (
    <Box bg="#000321" color="white" position="relative">
      <Container maxW="container.xl" py={16}>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 5 }} spacing={10}>
          {/* Brand Section */}
          <Stack spacing={6}>
            <Image
              src="/aidu-logo.svg"
              alt="AIDU Logo"
              h="50px"
              w="auto"
              filter="brightness(0) invert(1)"
            />
          </Stack>

          {/* Product Links */}
          <Stack spacing={4}>
            <Text
              fontWeight="bold"
              fontSize="sm"
              textTransform="uppercase"
              color="rgba(255, 255, 255, 0.6)"
            >
              {t.product}
            </Text>
            {t.footerLinks.product.map((link) => (
              <Link
                key={link.label}
                fontSize="sm"
                color="rgba(255, 255, 255, 0.8)"
                _hover={{ color: "#FF6A5F", textDecoration: "none" }}
                onClick={() => navigate(link.path)}
                cursor="pointer"
                transition="all 0.3s"
              >
                {link.label}
              </Link>
            ))}
          </Stack>

          {/* Company Links */}
          <Stack spacing={4}>
            <Text
              fontWeight="bold"
              fontSize="sm"
              textTransform="uppercase"
              color="rgba(255, 255, 255, 0.6)"
            >
              {t.company}
            </Text>
            {t.footerLinks.company.map((link) => (
              <Link
                key={link.label}
                fontSize="sm"
                color="rgba(255, 255, 255, 0.8)"
                _hover={{ color: "#FF6A5F", textDecoration: "none" }}
                onClick={() => navigate(link.path)}
                cursor="pointer"
                transition="all 0.3s"
              >
                {link.label}
              </Link>
            ))}
          </Stack>

          {/* Resources Links */}
          <Stack spacing={4}>
            <Text
              fontWeight="bold"
              fontSize="sm"
              textTransform="uppercase"
              color="rgba(255, 255, 255, 0.6)"
            >
              {t.resources}
            </Text>
            {t.footerLinks.resources.map((link) => (
              <Link
                key={link.label}
                fontSize="sm"
                color="rgba(255, 255, 255, 0.8)"
                _hover={{ color: "#FF6A5F", textDecoration: "none" }}
                onClick={() => navigate(link.path)}
                cursor="pointer"
                transition="all 0.3s"
              >
                {link.label}
              </Link>
            ))}
          </Stack>

          {/* Legal Links */}
          <Stack spacing={4}>
            <Text
              fontWeight="bold"
              fontSize="sm"
              textTransform="uppercase"
              color="rgba(255, 255, 255, 0.6)"
            >
              {t.legal}
            </Text>
            {t.footerLinks.legal.map((link) => (
              <Link
                key={link.label}
                fontSize="sm"
                color="rgba(255, 255, 255, 0.8)"
                _hover={{ color: "#FF6A5F", textDecoration: "none" }}
                onClick={() => navigate(link.path)}
                cursor="pointer"
                transition="all 0.3s"
              >
                {link.label}
              </Link>
            ))}
          </Stack>
        </SimpleGrid>

        <Divider my={10} borderColor="rgba(255, 255, 255, 0.1)" />

        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          gap={6}
        >
          <Text fontSize="sm" color="rgba(255, 255, 255, 0.6)">
            {t.copyright}
          </Text>
          <Flex gap={8}>
            <Link
              fontSize="sm"
              color="rgba(255, 255, 255, 0.6)"
              _hover={{ color: "white", textDecoration: "none" }}
              href="#"
            >
              Privacy Policy
            </Link>
            <Link
              fontSize="sm"
              color="rgba(255, 255, 255, 0.6)"
              _hover={{ color: "white", textDecoration: "none" }}
              href="#"
            >
              Terms & Conditions
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
